import React from 'react'
import {StyleSheet, Font} from '@react-pdf/renderer'
import roboto from 'url:../../../resources/fonts/Roboto-Regular.ttf'
import robotoBlack from 'url:../../../resources/fonts/Roboto-Black.ttf'

Font.register({family: 'Roboto', src: roboto })
Font.register({family: 'RobotoBlack', src: robotoBlack})

const activityStyles = name => ({
  [`activity${name}Select`]: {marginTop: 7},
  [`activity${name}Textarea`]: {marginTop: 10, marginBottom: 10}
})

const activity = {
  ...activityStyles('beginning'),
  ...activityStyles('development'),
  ...activityStyles('ending')
}

const field = {
  field: {
    marginTop: -1,
    padding: '10',
    borderColor: '#2c75bd',
    borderWidth: 1,
    borderStyle: 'solid',
    borderTopWidth: 0,
  },
  checkmark: {
    marginTop: 0,
    width: 15,
    height: 15,
  },
  selectLabel: {
    fontSize: 11,
    color: '#2c75bd'
  },
  selectText: {
    paddingLeft: 3
  },
  checkbox: {
    flexDirection: 'row'
  },
  textareaText: {
    color: 'grey',
    textAlign: 'justify'
  },
  levelField: {
    flexDirection: 'row'
  },
  levelCheckbox: {
    flexGrow: 1,
    flexWrap: 'wrap'
  },
  assignmentField: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  assignmentCheckbox: {
    flexGrow: 1,
  },
  assignmentTextarea: {
    width: '100%',
    margin: '10 0'
  },
  objectivesPanel: {
    marginTop: 8
  },
  objectivesSelectText: {
    paddingLeft: '0 !important'
  },
  objectivesPanel0: {
    martinTop: '0 !important'
  },
  objectivesDropdown0: {
    fontFamily: 'RobotoBlack',
    marginRight: 3
  },
  objectivesPanelChildren: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingTop: 8
  },
  objectivesTextarea: {
    margin: '8 0 15 0',
    width: '100%'
  },
  objectivesDropdown: {
    flexGrow: 0
  },
  strategiesSelects: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '5 5 10 5',
  },
  strategiesSelect: {
    flexGrow: 1
  },
  materialsSelects: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  materialsSelect: {
    flexGrow: 1
  },
  materialsTextarea: {
    margin: '10 0'
  },
  technologyresourcesSelects: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  technologyresourcesSelect: {
    flexGrow: 1
  },
  technologyresourcesTextarea: {
    margin: '10 0'
  },
  connectionPanel: {
    marginTop: 10
  },
  differentiatedstrategyPanel: {
    marginTop: 10
  },
  differentiatedstrategySelect: {
    marginTop: 8,
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  differentiatedstrategySelectLabel: {
    marginRight: 5 
  },
  differentiatedstrategyTextarea: {
    marginTop: 10,
    marginBottom: 10
  },
  evaluationSelects: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  evaluationSelect: {
    flexGrow: 1,
    marginRight: 8
  },
  evaluationTextarea: {
    marginTop: 10,
    marginBottom: 10
  },

}

const labeledInfo = {
  labeledInfo: {
    flexGrow: 1
  },
  labeledInfoLabel: {
    fontSize: 11.5,
    color: '#2c75bd'
  },
  labeledInfoContent: {
    paddingLeft: 3
  },
}

const standards = {
  editionGroup: {
    marginBottom: 16
  },
  editionHeading: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#294e73',
    backgroundColor: '#eaf2fa',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderLeftWidth: 4,
    borderLeftColor: '#477eaf',
    marginBottom: 0
  },
  standard: {
    flexDirection: 'column'
  },
  expectation: {
    padding: '4 5'
  },
  expectationTitle: {
    fontSize: 11.5,
    color: '#787B7B'
  },
  indicator: {
    paddingTop: '4'
  },
  indicators: {
    padding: '4 5'
  },
  standardLabel: {
    fontSize: 11,
    color: '#2c75bd'
  },
  indicatorCode: {
    fontFamily: 'RobotoBlack'
  },
  indicatorName: {
    fontSize: 10.5,
    padding: '5 0',
    color: '#787B7B'
  }
}

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    fontSize: 12,
    padding: '35 20',
    color: '#787b7b'
  },
  header: {
    position: 'absolute',
    fontSize: 10,
    left: 20,
    right: 20,
    top: 10,
  },
  headerTitle: {
    position: 'absolute',
    left: 0
  },
  groupRange: {
    position: 'absolute',
    right: 0,
  },
  footer: {
    position: 'absolute',
    bottom: 15,
    fontSize: 10,
  },
  author: {
    position: 'absolute',
    left: 15,
  },
  paging: {
    position: 'absolute',
    right: 15,
  },
  plan: {
    marginBottom: 30
  },
  content: {
    borderWidth: 1,
    borderColor: '#2c75bd',
    borderStyle: 'solid',
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0
  },
  info: {
    flexDirection: 'row',
    padding: '5 10',
    borderWidth: 1,
    borderColor: '#2c75bd',
    borderStyle: 'solid',
    borderTopWidth: 0
  },
  title: {
    marginTop: -1,
    fontSize: 13,
    padding: '5 10',
    border: 'none',
    backgroundColor: '#2c75bd',
    color: '#fff'
  },
  ...labeledInfo,
  ...standards,
  ...field,
  ...activity
})

export {styles as default}
